import Modal from 'antd/es/modal/Modal';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import * as modalTypes from '../../consts/modals/modalTypes';
import {hideModalAction} from '../../state/ducks/modal';
import {selectGlobalModals} from '../../state/selectors/modal';
import OrganizationBuildingModal from './components/BuildingModals/OrganizationBuildingModal/OrganizationBuildingModal';
import BuildingProfileModal from './components/BuildingProfileModals/BuildingProfileModal/BuildingProfileModal';
import UploadFileModal from './components/BuildingProfileModals/BuildingProfileModal/UploadFileModal';
import RoomToBuildingModal from './components/BuildingProfileModals/RoomToBuildingModal/RoomToBuildingModal';
import ConfigureServiceKyivEnergoModal from './components/ConfigureKyivEnergoModal/ConfigureServiceKyivEnergoModal';
import ConfigureServiceKvkModal from './components/ConfigureServiceKvkModal/ConfigureServiceKvkModal';
import ConfigureServiceLvkModal from './components/ConfigureServiceLvkModal/ConfigureServiceLvkModal';
import ConfigureServiceModal from './components/ConfigureServiceModal/ServiceSettingsModal';
import ConfirmModal from './components/ConfirmModal/ConfirmModal';
import DataCollectorModal from './components/DataCollectorModal/DataCollectorModal';
import DeviceModal from './components/DeviceModal/DeviceModal';
import GatewayModal from './components/GatewayModal/GatewayModal';
import MapModal from './components/MapModal/MapModal';
import OrganizationModal from './components/OrganizationModal/OrganizationModal';
import ReportsModal from './components/ReportsModal/ReportsModal';
import RoomProfileModal from './components/RoomProfileModals/RoomProfileModal/RoomProfileModal';
import ArsBuildingsModal from './components/ServiceArs/ArsBuildingModal/ArsBuildingsModal';
import ArsOrganizationModal from './components/ServiceArs/ArsOrganizationModal/ArsOrganizationModal';
import ArsStatisticsOrganizationModal from './components/ServiceArs/ArsStatisticsOrganizationModal/ArsStatisticsOrganizationModal';
import AddUlcModal from './components/ServiceKyivenergo/AddUlcModal/AddUlcModal';
import ServicesAddBuildingModal from './components/ServicesAddBuildingModal/ServicesAddBuildingModal';
import ChirpStackProfileModal from './components/SettingsModals/ChirpStackProfileModal/ChirpStackProfileModal';
import CityModal from './components/SettingsModals/CityModal/CityModal';
import DCModelModal from './components/SettingsModals/DCModelModal/DCModelModal';
import DeviceModelModal from './components/SettingsModals/DeviceGroupsModal/DeviceGroupModelsModal/DeviceModelModal';
import DeviceGroupsModal from './components/SettingsModals/DeviceGroupsModal/DeviceGroupsModal';
import RoomsModal from './components/SettingsModals/RoomsModal/RoomsModal';
import UserModal from './components/UserModal/UserModal';

const MODAL_COMPONENTS = {
    [modalTypes.EDIT_USERS_MODAL_TYPE]: UserModal,
    [modalTypes.ADD_USERS_MODAL_TYPE]: UserModal,
    [modalTypes.ADD_USERS_TO_BUILDING_MODAL_TYPE]: UserModal,

    [modalTypes.ADD_USER_OBJECTS_MODAL_TYPE]: UserModal,
    [modalTypes.EDIT_USER_OBJECTS_MODAL_TYPE]: UserModal,

    [modalTypes.ORGANIZATION_CREATE_MODAL]: OrganizationModal,
    [modalTypes.ORGANIZATION_COPY_MODAL]: OrganizationModal,
    [modalTypes.ORGANIZATION_EDIT_MODAL]: OrganizationModal,

    [modalTypes.SERVICES_BUILDING_ADD]: ServicesAddBuildingModal,

    [modalTypes.SERVICES_ADD_ULC]: AddUlcModal,
    [modalTypes.SERVICES_EDIT_ULC]: AddUlcModal,

    [modalTypes.ADD_ARS_ORGANIZATION_MODAL_TYPE]: ArsOrganizationModal,
    [modalTypes.EDIT_ARS_ORGANIZATION_MODAL_TYPE]: ArsOrganizationModal,

    [modalTypes.ADD_BUILDINGS_TO_ARS_MODAL_TYPE]: ArsBuildingsModal,

    [modalTypes.ARS_STATISTIC_ORGANIZATION_MODAL_TYPE]: ArsStatisticsOrganizationModal,

    [modalTypes.SERVICES_CONFIGURE_KYIVENERGO]: ConfigureServiceKyivEnergoModal,

    [modalTypes.SERVICES_CONFIGURE_LVK]: ConfigureServiceLvkModal,

    [modalTypes.SERVICES_CONFIGURE_KVK]: ConfigureServiceKvkModal,

    [modalTypes.SERVICES_CONFIGURE_SERVICE]: ConfigureServiceModal,

    [modalTypes.REPORTS_MODAL]: ReportsModal,

    [modalTypes.CREATE_DATA_COLLECTOR_MODAL]: DataCollectorModal,
    [modalTypes.ADD_DATA_COLLECTOR_TO_BUILDING_MODAL]: DataCollectorModal,
    [modalTypes.COPY_DATA_COLLECTOR_MODAL]: DataCollectorModal,
    [modalTypes.EDIT_DATA_COLLECTOR_MODAL]: DataCollectorModal,

    [modalTypes.EDIT_MODEMS_TAB_MODAL]: DataCollectorModal,
    [modalTypes.COPY_MODEMS_TAB_MODAL]: DataCollectorModal,

    [modalTypes.CREATE_BUILDING_MODAL]: OrganizationBuildingModal,
    [modalTypes.EDIT_BUILDING_MODAL]: OrganizationBuildingModal,
    [modalTypes.COPY_BUILDING_MODAL]: OrganizationBuildingModal,

    [modalTypes.COMMON_SETTINGS_TAB_ADD_CITY]: CityModal,

    [modalTypes.SETTING_ADD_ROOM_TYPE]: RoomsModal,
    [modalTypes.SETTING_EDIT_ROOM_TYPE]: RoomsModal,

    [modalTypes.ADD_ROOM_TO_BUILDING]: RoomToBuildingModal,

    [modalTypes.SETTINGS_ADD_DC_MODEL_TYPE]: DCModelModal,
    [modalTypes.SETTINGS_EDIT_DC_MODEL_TYPE]: DCModelModal,

    [modalTypes.SETTINGS_ADD_CHIRPSTACK_PROFILE_TYPE]: ChirpStackProfileModal,
    [modalTypes.SETTINGS_EDIT_CHIRPSTACK_PROFILE_TYPE]: ChirpStackProfileModal,

    [modalTypes.ADD_DEVICE_MODAL_TYPE]: DeviceModal,
    [modalTypes.EDIT_DEVICE_MODAL_TYPE]: DeviceModal,

    [modalTypes.BUILDING_PROFILE_MODAL_TYPE]: BuildingProfileModal,

    [modalTypes.UPLOAD_FILE_MODAL_TYPE]: UploadFileModal,

    [modalTypes.ROOM_PROFILE_MODAL_TYPE]: RoomProfileModal,

    [modalTypes.SETTINGS_ADD_DEVICE_MODEL]: DeviceModelModal,
    [modalTypes.SETTINGS_EDIT_DEVICE_MODEL]: DeviceModelModal,

    [modalTypes.SETTINGS_ADD_DEVICE_GROUPS]: DeviceGroupsModal,
    [modalTypes.SETTINGS_EDIT_DEVICE_GROUPS]: DeviceGroupsModal,

    [modalTypes.CONFIRM_MODAL_TYPE]: ConfirmModal,

    [modalTypes.MAP_MODAL_TYPE]: MapModal,

    [modalTypes.CREATE_GATEWAY_MODAL]: GatewayModal,
    [modalTypes.EDIT_GATEWAY_MODAL]: GatewayModal,
};

const SETTINGS_FORM_MODAL_TYPES = [
    modalTypes.COMMON_SETTINGS_TAB_ADD_CITY,
    modalTypes.SETTING_ADD_ROOM_TYPE,
    modalTypes.SETTING_EDIT_ROOM_TYPE,
    modalTypes.SETTINGS_ADD_DC_MODEL_TYPE,
    modalTypes.SETTINGS_EDIT_DC_MODEL_TYPE,
    modalTypes.SETTINGS_ADD_CHIRPSTACK_PROFILE_TYPE,
    modalTypes.SETTINGS_EDIT_CHIRPSTACK_PROFILE_TYPE,
    modalTypes.SETTINGS_ADD_DEVICE_MODEL,
    modalTypes.SETTINGS_EDIT_DEVICE_MODEL,
    modalTypes.SETTINGS_ADD_DEVICE_GROUPS,
    modalTypes.SETTINGS_EDIT_DEVICE_GROUPS,
];

const PROPERTY_PROFILE_ACTION_MODAL_TYPES = [
    modalTypes.ADD_DEVICE_MODAL_TYPE,
    modalTypes.EDIT_DEVICE_MODAL_TYPE,
    modalTypes.BUILDING_PROFILE_MODAL_TYPE,
    modalTypes.ADD_ROOM_TO_BUILDING,
    modalTypes.UPLOAD_FILE_MODAL_TYPE,
    modalTypes.ROOM_PROFILE_MODAL_TYPE,
];

const ModalsRoot = () => {
    const modals = useSelector(selectGlobalModals);
    const dispatch = useDispatch();
    const isSettingsFormModalOpen = modals.some(({modalType}) => SETTINGS_FORM_MODAL_TYPES.includes(modalType));
    const isPropertyProfileActionModalOpen = modals.some(({modalType}) =>
        PROPERTY_PROFILE_ACTION_MODAL_TYPES.includes(modalType)
    );
    const isArsBuildingsModalOpen = modals.some(
        ({modalType}) => modalType === modalTypes.ADD_BUILDINGS_TO_ARS_MODAL_TYPE
    );

    React.useEffect(() => {
        if (!isSettingsFormModalOpen) return undefined;

        document.body.classList.add('settings-form-modal-open');

        return () => document.body.classList.remove('settings-form-modal-open');
    }, [isSettingsFormModalOpen]);

    React.useEffect(() => {
        if (!isPropertyProfileActionModalOpen) return undefined;

        document.body.classList.add('property-profile-action-modal-open');

        return () => document.body.classList.remove('property-profile-action-modal-open');
    }, [isPropertyProfileActionModalOpen]);

    React.useEffect(() => {
        if (!isArsBuildingsModalOpen) return undefined;

        document.body.classList.add('ars-buildings-modal-open');

        return () => document.body.classList.remove('ars-buildings-modal-open');
    }, [isArsBuildingsModalOpen]);

    if (!modals.length) return null;

    return (
        <>
            {modals.map((modal) => {
                const {modalType, modalProps} = modal;
                const isConfirmModal = modalType === modalTypes.CONFIRM_MODAL_TYPE;
                const SpecificModal = MODAL_COMPONENTS[modalType];
                const isOrganizationModal = [
                    modalTypes.ORGANIZATION_CREATE_MODAL,
                    modalTypes.ORGANIZATION_EDIT_MODAL,
                    modalTypes.ORGANIZATION_COPY_MODAL,
                ].includes(modalType);
                const isDataCollectorModal = [
                    modalTypes.CREATE_DATA_COLLECTOR_MODAL,
                    modalTypes.ADD_DATA_COLLECTOR_TO_BUILDING_MODAL,
                    modalTypes.COPY_DATA_COLLECTOR_MODAL,
                    modalTypes.EDIT_DATA_COLLECTOR_MODAL,
                    modalTypes.EDIT_MODEMS_TAB_MODAL,
                    modalTypes.COPY_MODEMS_TAB_MODAL,
                ].includes(modalType);
                const isBuildingModal = [
                    modalTypes.CREATE_BUILDING_MODAL,
                    modalTypes.EDIT_BUILDING_MODAL,
                    modalTypes.COPY_BUILDING_MODAL,
                ].includes(modalType);
                const isGatewayModal = [modalTypes.CREATE_GATEWAY_MODAL, modalTypes.EDIT_GATEWAY_MODAL].includes(
                    modalType
                );
                const isReportsModal = modalType === modalTypes.REPORTS_MODAL;
                const isArsOrganizationModal = [
                    modalTypes.ADD_ARS_ORGANIZATION_MODAL_TYPE,
                    modalTypes.EDIT_ARS_ORGANIZATION_MODAL_TYPE,
                ].includes(modalType);
                const isArsStatisticsModal = modalType === modalTypes.ARS_STATISTIC_ORGANIZATION_MODAL_TYPE;
                const isArsBuildingsModal = modalType === modalTypes.ADD_BUILDINGS_TO_ARS_MODAL_TYPE;
                const isUlcModal = [modalTypes.SERVICES_ADD_ULC, modalTypes.SERVICES_EDIT_ULC].includes(modalType);
                const isServiceSettingsModal = [
                    modalTypes.SERVICES_CONFIGURE_KYIVENERGO,
                    modalTypes.SERVICES_CONFIGURE_KVK,
                    modalTypes.SERVICES_CONFIGURE_LVK,
                ].includes(modalType);
                const isDeviceModal = [modalTypes.ADD_DEVICE_MODAL_TYPE, modalTypes.EDIT_DEVICE_MODAL_TYPE].includes(
                    modalType
                );
                const isBuildingProfileModal = modalType === modalTypes.BUILDING_PROFILE_MODAL_TYPE;
                const isRoomToBuildingModal = modalType === modalTypes.ADD_ROOM_TO_BUILDING;
                const isUploadFileModal = modalType === modalTypes.UPLOAD_FILE_MODAL_TYPE;
                const isRoomProfileModal = modalType === modalTypes.ROOM_PROFILE_MODAL_TYPE;
                const isSettingsFormModal = SETTINGS_FORM_MODAL_TYPES.includes(modalType);
                const isUserModal = [
                    modalTypes.ADD_USERS_MODAL_TYPE,
                    modalTypes.EDIT_USERS_MODAL_TYPE,
                    modalTypes.ADD_USERS_TO_BUILDING_MODAL_TYPE,
                    modalTypes.ADD_USER_OBJECTS_MODAL_TYPE,
                    modalTypes.EDIT_USER_OBJECTS_MODAL_TYPE,
                ].includes(modalType);
                const wrapClassName = isConfirmModal
                    ? 'action-confirm-modal py-20'
                    : isOrganizationModal
                    ? 'organization-create-modal py-20'
                    : isDataCollectorModal
                    ? 'data-collector-modal py-20'
                    : isBuildingModal
                    ? 'building-modal py-20'
                    : isGatewayModal
                    ? 'gateway-modal py-20'
                    : isReportsModal
                    ? 'reports-modal py-20'
                    : isArsOrganizationModal
                    ? 'ars-organization-modal py-20'
                    : isArsStatisticsModal
                    ? 'ars-statistics-modal py-20'
                    : isArsBuildingsModal
                    ? 'ars-buildings-modal py-20'
                    : isUlcModal
                    ? 'ulc-edit-modal py-20'
                    : isServiceSettingsModal
                    ? 'service-settings-modal py-20'
                    : isDeviceModal
                    ? 'device-modal py-20'
                    : isBuildingProfileModal
                    ? 'building-profile-modal py-20'
                    : isRoomToBuildingModal
                    ? 'room-to-building-modal py-20'
                    : isUploadFileModal
                    ? 'upload-file-modal py-20'
                    : isRoomProfileModal
                    ? 'room-profile-modal py-20'
                    : isSettingsFormModal
                    ? 'settings-form-modal py-20'
                    : isUserModal
                    ? 'user-modal py-20'
                    : modalType === modalTypes.MAP_MODAL_TYPE
                    ? 'address-map-modal py-20'
                    : 'py-20';

                return SpecificModal ? (
                    <Modal
                        footer={null}
                        key={modalType}
                        centered
                        closable={false}
                        width='820px'
                        open={!!modalType}
                        wrapClassName={wrapClassName}
                        {...modalProps}
                        {...(isConfirmModal && {
                            rootClassName: 'action-confirm-root',
                            zIndex: 1200,
                            onCancel: () => {
                                modalProps?.onCancel?.();
                                dispatch(hideModalAction(modalTypes.CONFIRM_MODAL_TYPE));
                            },
                        })}
                    >
                        <SpecificModal {...modalProps} modalType={modalType} dispatch={dispatch} />
                    </Modal>
                ) : null;
            })}
        </>
    );
};

export default ModalsRoot;
